import { useApi } from "../../../swr/useApi";
import { salesService } from "../../api_client";
import type { SaleStatsDto } from "../../../api";

export function useAdminSalesStats() {
  return useApi<SaleStatsDto>("admin-sales-stats", () =>
    salesService.getSalesStats(),
  );
}
